// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq-page {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: var(--bg-white);
  overflow-y: auto;
  animation: faqPageIn 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes faqPageIn {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.faq-page__header {
  position: sticky;
  top: 0;
  z-index: 3;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--border-soft);
}

.faq-page__header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 68px;
}

.faq-page__back {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-display);
  font-size: 14px;
  font-weight: 700;
  color: var(--text-dark);
  background: transparent;
}

.faq-page__back:hover {
  color: var(--teal-dark);
}

.faq-page__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font-display);
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--teal-dark);
  background: var(--teal-tint);
  padding: 6px 14px;
  border-radius: 100px;
}

.faq-page__audiencebar {
  position: sticky;
  top: 68px;
  z-index: 2;
  background: var(--bg-white);
  border-bottom: 1px solid var(--border-soft);
}

.faq-page__audiencebar-inner {
  display: flex;
  gap: 8px;
  padding-top: 4px;
}

.faq-page__audience {
  padding: 14px 18px;
  font-family: var(--font-display);
  font-size: 13.5px;
  font-weight: 700;
  color: var(--text-grey);
  background: transparent;
  border-bottom: 2.5px solid transparent;
  white-space: nowrap;
}

.faq-page__audience--active.faq-page__audience--teal {
  color: var(--teal-dark);
  border-bottom-color: var(--teal);
}

.faq-page__audience--active.faq-page__audience--amber {
  color: var(--amber-dark);
  border-bottom-color: var(--amber);
}

.faq-page__audience--active.faq-page__audience--emerald {
  color: var(--emerald-dark);
  border-bottom-color: var(--emerald);
}

.faq-page__body {
  padding: 40px 24px 100px;
  max-width: 860px;
}

.faq-page__intro h1 {
  font-size: clamp(26px, 4vw, 34px);
  font-weight: 800;
}

.faq-page__intro p {
  margin-top: 8px;
  font-size: 14.5px;
}

.faq-page__search {
  position: relative;
  margin-top: 28px;
}

.faq-page__search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--teal-dark);
  pointer-events: none;
}

.faq-page__search input {
  width: 100%;
  padding: 15px 16px 15px 46px;
  font-family: var(--font-body);
  font-size: 14.5px;
  color: var(--text-dark);
  background: var(--bg-light);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-md);
}

.faq-page__search input::placeholder {
  color: var(--text-mute);
}

.faq-page__search input:focus {
  outline: none;
  border-color: var(--teal);
  background: var(--bg-white);
}

.faq-page__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 18px;
}

.faq-page__chip {
  padding: 9px 16px;
  font-family: var(--font-display);
  font-size: 12.5px;
  font-weight: 700;
  color: var(--text-grey);
  background: var(--bg-white);
  border: 1px solid var(--border-soft);
  border-radius: 100px;
}

.faq-page__chip--active {
  color: #fff;
  background: var(--teal);
  border-color: var(--teal);
}

.faq-page__content {
  margin-top: 32px;
}

.faq-page__category {
  margin-bottom: 30px;
}

.faq-page__category-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.faq-page__category-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: var(--teal-tint);
  color: var(--teal-dark);
}

.faq-page__category-head h3 {
  font-size: 16px;
  font-weight: 800;
}

.faq-item {
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-md);
  margin-bottom: 10px;
  overflow: hidden;
  background: var(--bg-white);
}

.faq-item__q {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
  text-align: left;
  font-family: var(--font-display);
  font-size: 14.5px;
  font-weight: 700;
  color: var(--text-dark);
  background: transparent;
}

.faq-item__chevron {
  flex-shrink: 0;
  color: var(--teal-dark);
  transition: transform 0.2s ease;
}

.faq-item--open .faq-item__chevron {
  transform: rotate(180deg);
}

.faq-item__a-wrap {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.22s ease;
}

.faq-item--open .faq-item__a-wrap {
  grid-template-rows: 1fr;
}

.faq-item__a-wrap > .faq-item__a {
  overflow: hidden;
  margin: 0;
  padding: 0 18px;
  font-size: 13.5px;
  line-height: 1.7;
}

.faq-item--open .faq-item__a-wrap > .faq-item__a {
  padding: 0 18px 18px;
}

.faq-page__flat-item {
  margin-bottom: 16px;
}

.faq-page__flat-cat {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  font-family: var(--font-display);
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--teal-dark);
}

.faq-page__empty {
  margin-top: 24px;
  font-size: 14.5px;
}

@media (max-width: 640px) {
  .faq-page__body {
    padding: 32px 20px 80px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FaqPage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,qCAAqC;EACrC,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;EAC3B,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".faq-page {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  background: var(--bg-white);\n  overflow-y: auto;\n  animation: faqPageIn 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes faqPageIn {\n  from {\n    opacity: 0;\n    transform: translateY(14px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.faq-page__header {\n  position: sticky;\n  top: 0;\n  z-index: 3;\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid var(--border-soft);\n}\n\n.faq-page__header-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 68px;\n}\n\n.faq-page__back {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: var(--font-display);\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-dark);\n  background: transparent;\n}\n\n.faq-page__back:hover {\n  color: var(--teal-dark);\n}\n\n.faq-page__eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-family: var(--font-display);\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: var(--teal-dark);\n  background: var(--teal-tint);\n  padding: 6px 14px;\n  border-radius: 100px;\n}\n\n.faq-page__audiencebar {\n  position: sticky;\n  top: 68px;\n  z-index: 2;\n  background: var(--bg-white);\n  border-bottom: 1px solid var(--border-soft);\n}\n\n.faq-page__audiencebar-inner {\n  display: flex;\n  gap: 8px;\n  padding-top: 4px;\n}\n\n.faq-page__audience {\n  padding: 14px 18px;\n  font-family: var(--font-display);\n  font-size: 13.5px;\n  font-weight: 700;\n  color: var(--text-grey);\n  background: transparent;\n  border-bottom: 2.5px solid transparent;\n  white-space: nowrap;\n}\n\n.faq-page__audience--active.faq-page__audience--teal {\n  color: var(--teal-dark);\n  border-bottom-color: var(--teal);\n}\n\n.faq-page__audience--active.faq-page__audience--amber {\n  color: var(--amber-dark);\n  border-bottom-color: var(--amber);\n}\n\n.faq-page__audience--active.faq-page__audience--emerald {\n  color: var(--emerald-dark);\n  border-bottom-color: var(--emerald);\n}\n\n.faq-page__body {\n  padding: 40px 24px 100px;\n  max-width: 860px;\n}\n\n.faq-page__intro h1 {\n  font-size: clamp(26px, 4vw, 34px);\n  font-weight: 800;\n}\n\n.faq-page__intro p {\n  margin-top: 8px;\n  font-size: 14.5px;\n}\n\n.faq-page__search {\n  position: relative;\n  margin-top: 28px;\n}\n\n.faq-page__search-icon {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--teal-dark);\n  pointer-events: none;\n}\n\n.faq-page__search input {\n  width: 100%;\n  padding: 15px 16px 15px 46px;\n  font-family: var(--font-body);\n  font-size: 14.5px;\n  color: var(--text-dark);\n  background: var(--bg-light);\n  border: 1px solid var(--border-soft);\n  border-radius: var(--radius-md);\n}\n\n.faq-page__search input::placeholder {\n  color: var(--text-mute);\n}\n\n.faq-page__search input:focus {\n  outline: none;\n  border-color: var(--teal);\n  background: var(--bg-white);\n}\n\n.faq-page__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 18px;\n}\n\n.faq-page__chip {\n  padding: 9px 16px;\n  font-family: var(--font-display);\n  font-size: 12.5px;\n  font-weight: 700;\n  color: var(--text-grey);\n  background: var(--bg-white);\n  border: 1px solid var(--border-soft);\n  border-radius: 100px;\n}\n\n.faq-page__chip--active {\n  color: #fff;\n  background: var(--teal);\n  border-color: var(--teal);\n}\n\n.faq-page__content {\n  margin-top: 32px;\n}\n\n.faq-page__category {\n  margin-bottom: 30px;\n}\n\n.faq-page__category-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.faq-page__category-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 9px;\n  background: var(--teal-tint);\n  color: var(--teal-dark);\n}\n\n.faq-page__category-head h3 {\n  font-size: 16px;\n  font-weight: 800;\n}\n\n.faq-item {\n  border: 1px solid var(--border-soft);\n  border-radius: var(--radius-md);\n  margin-bottom: 10px;\n  overflow: hidden;\n  background: var(--bg-white);\n}\n\n.faq-item__q {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 18px;\n  text-align: left;\n  font-family: var(--font-display);\n  font-size: 14.5px;\n  font-weight: 700;\n  color: var(--text-dark);\n  background: transparent;\n}\n\n.faq-item__chevron {\n  flex-shrink: 0;\n  color: var(--teal-dark);\n  transition: transform 0.2s ease;\n}\n\n.faq-item--open .faq-item__chevron {\n  transform: rotate(180deg);\n}\n\n.faq-item__a-wrap {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.22s ease;\n}\n\n.faq-item--open .faq-item__a-wrap {\n  grid-template-rows: 1fr;\n}\n\n.faq-item__a-wrap > .faq-item__a {\n  overflow: hidden;\n  margin: 0;\n  padding: 0 18px;\n  font-size: 13.5px;\n  line-height: 1.7;\n}\n\n.faq-item--open .faq-item__a-wrap > .faq-item__a {\n  padding: 0 18px 18px;\n}\n\n.faq-page__flat-item {\n  margin-bottom: 16px;\n}\n\n.faq-page__flat-cat {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 6px;\n  font-family: var(--font-display);\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--teal-dark);\n}\n\n.faq-page__empty {\n  margin-top: 24px;\n  font-size: 14.5px;\n}\n\n@media (max-width: 640px) {\n  .faq-page__body {\n    padding: 32px 20px 80px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
